const initialState = {
    blacklistedUsers: []
};

const BlacklistReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case 'UPDATE_BLACKLISTED_USERS':
            return {
                ...state,
                blacklistedUsers: action.payload
            };
        default:
            return state;
    }
};

export default BlacklistReducer;
